import { render, staticRenderFns } from "./HeaderAdd.vue?vue&type=template&id=2ecabaf4"
import script from "./HeaderAdd.vue?vue&type=script&lang=js"
export * from "./HeaderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports